<template>
    <div class="container change-box">
        <div class="row">
            <h1>{{ say.edit_email_password }}</h1>
        </div>
        <div class="row change-box__form">
            <div class="col-12">
                <user-edit-credentials />
            </div>
        </div>
        <template v-if="showTwoFactor">
            <div class="row">
                <h1>{{ say.two_factor_auth || 'Uwierzytelnianie dwuskładnikowe (2FA)' }}</h1>
            </div>
            <div class="row change-box__form">
                <div class="col-12">
                    <user-form-two-factor />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import UserEditCredentials from '@/views/UserEditCredentials';
    import UserFormTwoFactor from '@/components/UserFormTwoFactor';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            UserEditCredentials,
            UserFormTwoFactor,
        },
        computed: {
            ...mapGetters(['say', 'user']),
            isAdmin() {
                return this.user && this.user.roles.includes('ROLE_ADMIN');
            },
            isOperator() {
                return this.user.operator;
            },
            isOrganizer() {
                return this.user.organizer;
            },
            showTwoFactor() {
                return this.isAdmin || this.isOperator || this.isOrganizer;
            },
        },
    };
</script>

<style scoped>
    .change-box {
        margin-top: 32px;
    }
    .change-box__form {
        margin-top: 32px;
    }
</style>
